import React from 'react';
import { LogoSection, StyledCol, StyledRow } from '../styled';

const FooterLogoSection = () => (
  <StyledRow>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        {/* <a
          className="logo-bgd"
          href="https://vp2moet.edu.vn/"
          target="_blank"
          rel="noopener noreferrer">
          <img
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo-trung-tam-giao-duc-setdc.png'
            }
            alt="Logo Sách TPHCM"
          />
        </a>
        <div className="font-bold logo-part-text">
          TRUNG TÂM PHÁT TRIỂN GDĐT PHÍA NAM <br /> BỘ GIÁO DỤC VÀ ĐÀO TẠO
        </div>
        <div className="partner-text">
          ĐỐI TÁC NGHIÊN CỨU, ỨNG DỤNG KHCN VÀ CHUYỂN ĐỔI SỐ
        </div> */}
        <a className="logo-test360" href="/" rel="noopener noreferrer">
          <img
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo_hst_chu_den.png'
            }
            alt="Logo Test360"
          />
        </a>
      </LogoSection>
    </StyledCol>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        <a
          href="https://bachkhoa.tech/"
          target="_blank"
          rel="noopener noreferrer">
          <img
            className="logo-bachkhoa"
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo-khong-nen---color.png'
            }
            alt="Logo BKT"
          />
        </a>
        <div className="logo-text">TẬP ĐOÀN KHOA HỌC CÔNG NGHỆ BÁCH KHOA</div>
        <div className="address-text">
          Trụ sở chính:{' '}
          <a
            href="https://g.co/kgs/6cvFbhb"
            target="_blank"
            rel="noopener noreferrer">
            Số 3 Công Trường Quốc Tế, TPHCM
          </a>
        </div>
        <div className="phone-text">
          Điện thoại:{' '}
          <a target="_blank" href="tel:02871020246" rel="noopener noreferrer">
            (0287)102 0246
          </a>{' '}
          {' - '}
          <a target="_blank" href="tel:0903030246" rel="noopener noreferrer">
            090 303 0246
          </a>
        </div>
        <div className="address-text">
          CN Hà Nội:{' '}
          <span
          // href="https://g.co/kgs/SEu34ht"
          // target="_blank"
          // rel="noopener noreferrer"
          >
            279 Khuất Duy Tiến, Thanh Xuân, Hà Nội
          </span>
        </div>
        <div className="phone-text">
          Điện thoại:{' '}
          <a target="_blank" href="tel:0984268811" rel="noopener noreferrer">
            098 426 8811 
          </a>
        </div>
      </LogoSection>
    </StyledCol>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        <a
          className="logo-sach"
          href="https://www.stb.com.vn/vi/?view=home"
          target="_blank"
          rel="noopener noreferrer">
          <img
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo-stb.png'
            }
            alt="Logo Sách TPHCM"
          />
        </a>
        <div className="font-bold logo-part-text">
          CÔNG TY CỔ PHẦN <br /> SÁCH VÀ THIẾT BỊ TRƯỜNG HỌC TPHCM
        </div>
        <div className="partner-text">
          ĐƠN VỊ CUNG CẤP HỌC LIỆU SỐ BẢN QUYỀN
        </div>
      </LogoSection>
    </StyledCol>
  </StyledRow>
);

export default FooterLogoSection;
